export default {
  en: {
    'search_players': 'search players',
    'known_talents_only': 'known talents only',
    'positions': 'positions',
    '': '',
  }
};
